import { MAP_GLYPHS } from '@/shared/ui';

/**
 * Legacy marks the middle of a corridor with the journey's vehicle-category glyph
 * (`vehicleCat_<id>`, `mapping.js:534-537`). The id -> meaning table is legacy's own
 * (`sass/components/_vehiclecategories.scss`); lucide has no yak, so a paw stands in
 * for category 7.
 */
const VEHICLE_CATEGORY_GLYPHS: Record<number, string> = {
  /** Fixed-Wing — legacy `lc-plane` */
  1: MAP_GLYPHS.plane,
  /** Helicopter — legacy `lc-helicopter` */
  2: MAP_GLYPHS.helicopter,
  /** Road — legacy `lc-road` */
  3: MAP_GLYPHS.truck,
  /** Rail — legacy `lc-rail` */
  4: MAP_GLYPHS.train,
  /** River — legacy `lc-river` */
  5: MAP_GLYPHS.sailboat,
  /** Sea — legacy `lc-sea` */
  6: MAP_GLYPHS.ship,
  /** Pack Animals — legacy `lc-yak` */
  7: MAP_GLYPHS.pawPrint,
  /** Porter — legacy `lc-porter` */
  8: MAP_GLYPHS.person
};

export function vehicleCategoryGlyph(id?: number): string | undefined {
  return id === undefined ? undefined : VEHICLE_CATEGORY_GLYPHS[id];
}
